import { useRef } from 'react';
const useBroadcast = () => {
    const liveRegionRef = useRef(null);
    const broadcast = message => {
        message &&
            liveRegionRef.current?.broadcast({
                message,
            });
    };
    return [liveRegionRef, broadcast];
};
export { useBroadcast };
//# sourceMappingURL=useBroadcast.js.map